import { LottieLoader } from '../components/loader'
// import useCheckTokenExpiry from '../hooks/use-check-token-expiry';
// import useAuthenticateToken from '../hooks/use-authenticate-token';
import { useEffect, useMemo } from 'react';
import { useAppSelector } from '../redux/hook';

function Auth() {
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  
  useEffect(() => {
    if(loginUser?.uinfin){
      window.location.href = "/transfer/dashboard";
    }
}, [])
  //CHECK EXPIRY OF TIMESTAMP
  // useCheckTokenExpiry();

  // useAuthenticateToken();
 


  return (
    <LottieLoader />
  )
}

export default Auth